import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faPiggyBank as fasPiggyBank, faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imgBankmonitorLogoFullWhite from "@img/logos/bankmonitor-white.svg";
import { Button, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class Step1 extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center">
					<img src={imgBankmonitorLogoFullWhite} alt="Bankmonitor" width="164" height="25" loading="eager" />
					<hr />
					<div className="h2 mb-0 text-uppercase">
						Mennyi <strong>család- és lakástámogatást</strong> kaphatsz 2023-ban?
					</div>
					<hr />
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<List itemStyle="tick" variant="primary" size="lg" className="font-weight-bold mx-3 mt-3 mb-4">
						<List.Item>CSOK támogatás</List.Item>
						<List.Item>CSOK-hitel</List.Item>
						<List.Item>ÁFA kedvezmény</List.Item>
						<List.Item>Illetékmentesség</List.Item>
						<List.Item>Babaváró hitel</List.Item>
					</List>
					<div className="d-flex">
						<div className="text-center border-right px-3 py-1">
							<FontAwesomeIcon icon={fasPiggyBank} className="text-success" size="3x" />
						</div>
						<div className="px-3 py-1">
							<strong>Több millió</strong> forintot nyerhetsz a jó döntéssel!
						</div>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasPlay} />} className="text-uppercase">
						Kalkuláció indítása
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
